import {connect} from "react-redux";
import DoctypesSelect from "./../component/DoctypesSelect";
import {changeSelectedDoctype, changCoverLetters} from "./../actions/index";
import {
    getVisibleDoctypes,
    isDoctypeCoverLetter,
    getCurrencySymbol,
    getSelectedDoctype,
    getDoctypesPrices,
    getCoverLetters,
    getSelectedCoverLettersCount
} from "./../reducers/index";

const mapStateToProps = (state) => {
    return {
        doctypes: getVisibleDoctypes(state),
        doctypesPrices: getDoctypesPrices(state),
        coverLetters: getCoverLetters(state),
        selectedDoctype: getSelectedDoctype(state),
        isCoverLetter: isDoctypeCoverLetter(state),
        currencySymbol: getCurrencySymbol(state),
        selectedCoverLettersCount: getSelectedCoverLettersCount(state),
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        onChange: (doctypeId) => {
            dispatch(changeSelectedDoctype(doctypeId))
        },
        onChangeCoverLetters: (coverLetters) => {
            dispatch(changCoverLetters(coverLetters))
        },
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DoctypesSelect);